import { render, staticRenderFns } from "./WistiaVideo.vue?vue&type=template&id=0dafab96&scoped=true"
import script from "./WistiaVideo.vue?vue&type=script&lang=js"
export * from "./WistiaVideo.vue?vue&type=script&lang=js"
import style0 from "./WistiaVideo.vue?vue&type=style&index=0&id=0dafab96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dafab96",
  null
  
)

export default component.exports